import { Redirect, Route, Switch } from "react-router";
import { UsersScreen } from "../pages/admin/UsersScreen";
import { TRDScreen } from "../pages/admin/TRDScreen";
import { OrganizationChartScreen } from "../pages/admin/OrganizationChartScreen";
import { ConsecutiveSettled } from "../pages/admin/ConsecutiveSettled";
import { BackupComponent } from "../components/admin/Backup/BackupComponent";
import { Anulado } from "../components/admin/Utilities/Anulado/Anulado";
import {ParameterizationAdmin} from "../pages/admin/ParameterizationAdmin";

export const AdminDashboardRouter = () => {
  return (
    <div>
      <Switch>
        <Route path="/admin/dashboard/users" component={UsersScreen} />
        <Route path="/admin/dashboard/trd" component={TRDScreen} />
        <Route path="/admin/dashboard/backup" component={BackupComponent} />
        <Route
          path="/admin/dashboard/organizationchart"
          component={OrganizationChartScreen}
        />
        <Route
          path="/admin/dashboard/parameterization"
          component={ConsecutiveSettled}
        />
        <Route path={"/admin/dashboard/anulado"} component={Anulado} />
        <Route
          path="/admin/dashboard/parameterization-correspondence"
          component={ParameterizationAdmin}
        />
        <Redirect to="/admin/dashboard/users" />
      </Switch>
    </div>
  );
};
